import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { supabase } from "@/lib/supabaseClient";
import { useAuth } from "@/context/AuthContext";

export default function MessagesButton() {
  const { user } = useAuth() || {};
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!user?.id) return;

    const loadUnreadCount = async () => {
      try {
        const { data, error } = await supabase.rpc("get_unread_messages_count");
        if (!error && typeof data === "number") {
          setUnreadCount(data);
        }
      } catch (e) {
        console.error("[MessagesButton] load unread count", e);
      }
    };

    loadUnreadCount();

    // Rafraîchir toutes les 30 secondes
    const interval = setInterval(loadUnreadCount, 30000);

    // S'abonner aux nouveaux messages en temps réel
    const channel = supabase
      .channel("messages_updates")
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "messages",
        },
        () => {
          loadUnreadCount();
        }
      )
      .subscribe();

    return () => {
      clearInterval(interval);
      try {
        supabase.removeChannel(channel);
      } catch (_) {}
    };
  }, [user?.id]);

  return (
    <Link
      to="/messages"
      className="relative px-5 py-3 rounded-xl text-sm font-medium bg-white border border-gray-200 hover:bg-gray-50 transition-all duration-200 inline-flex items-center gap-2"
    >
      <Mail size={18} />
      <span>Messages</span>
      {unreadCount > 0 && (
        <span className="absolute -top-2 -right-2 min-w-[20px] h-5 flex items-center justify-center px-1.5 rounded-full bg-red-600 text-white text-xs font-bold shadow-lg">
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </Link>
  );
}